import { render, staticRenderFns } from "./SaleTrend.vue?vue&type=template&id=3b5d0df6&scoped=true"
import script from "./SaleTrend.vue?vue&type=script&lang=js"
export * from "./SaleTrend.vue?vue&type=script&lang=js"
import style0 from "./SaleTrend.vue?vue&type=style&index=0&id=3b5d0df6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d0df6",
  null
  
)

export default component.exports